import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../../healtheraComponents';
import { loadAnimation } from './shared';

const LoadingBox = () => {
  return <Box />;
};

const Box = styled.div`
  width: 500px;
  height: 500px;
  background-color: ${colors.GRAY_LIGHT};
  animation: ${loadAnimation} 0.7s linear alternate infinite;
`;

export default LoadingBox;
